import IconCommon, { DesignSystemIconType } from '@/components/Common/DesignSystem/Icon/IconCommon';
import clsx from 'clsx';
import React from 'react';

import BaseButton, { BaseLinkButtonProps, BaseRealButtonProps } from '../../BaseButton/BaseButton';
import styles from './NavigationBarIconButton.module.scss';

type BaseButtonProps = {
  type: DesignSystemIconType;
  count?: number;
  badge?: string;
  altText?: string;
};

type PseudoButtonProps = BaseButtonProps & Omit<BaseLinkButtonProps, 'children'>;
type RealButtonProps = BaseButtonProps & Omit<BaseRealButtonProps, 'children' | 'type'>;

/**
 * 내비게이션 바에 맞춰 스타일을 적용한 아이콘 버튼.
 */
const NavigationBarIconButton: React.FC<PseudoButtonProps | RealButtonProps> = ({
  className,
  type,
  count,
  badge,
  altText,
  ...props
}) => (
  <BaseButton className={clsx(styles.button, className)} {...props}>
    <IconCommon type={type} altText={altText} />
    {count !== undefined && count > 0 && <div className={styles.count}>{count}</div>}
    {badge && <div className={styles.badge}>{badge}</div>}
  </BaseButton>
);

export default NavigationBarIconButton;
